'use client';

import { Suspense } from 'react';
import { Toaster } from '@/components/ui/sonner';

export function ToastProvider() {
  return (
    <Suspense fallback={null}>
      <Toaster position="top-right" richColors />
    </Suspense>
  );
}
